import React, { useState } from "react";
import classes from './Disciplines.module.css';
import PropTypes from 'prop-types';
import Discipline from "../../Disciplines/Discipline";
import { useDispatch, useSelector } from "react-redux";
import { coursesApi, studyGroupsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { disciplineAction } from "../../../../store/discipline-slice";
import { Action, ActionsPopup } from "../../../UI/ActionsPopup";
import { useNavigate } from "react-router-dom";
import DynamicMessage from "../../../lms-shared/UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../../../lms-shared/models/DynamicMessageTypeEnum";

const Disciplines = ({ isEditable, filteredlist, courseSelected, selectDisciplineCB, addNew }) => {

    const dispatch = useDispatch();
    const texts = useSelector(state => state.translate.texts);
    const navigate = useNavigate();
    const [messagePopup, setMessagePopup] = useState()

    const duplicateDiscipline = (disciplineId) => {
        setMessagePopup(null)
        navigate(`${disciplineId}`, { state: { isDuplicateCourse: true } });

    }
    const onDuplicateDiscipline = (disciplineId) => {
        coursesApi.coursesDuplicateIdPost(disciplineId, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                dispatch(disciplineAction.add(resdata))
                setMessagePopup(<DynamicMessage
                    type={DynamicMessageTypeEnum.Warn}
                    content={texts.duplicateCourseMessage}
                    confirmFunc={() => duplicateDiscipline(resdata.id)}
                    showCancel={false}
                />)
            }
        })

    }

    const CreateNationalStudygroup = (disciplineId, disciplineName) => {
        const data = {
            courseId: disciplineId,
            name: disciplineName,
            allowSelfRegister: true,
        }
        studyGroupsApi.studyGroupsAddPost({ studyGroupAddInput: data }, (error, resdata, response) => {
            if (error) {
                let message = texts.studyGroupsAddError
                if (error.status == 406)
                    message = texts.selfRegisteredstudyGroupExistforthisCourse
                dispatch(throwApiError({ userMessage: message, error: error, statusCode: response?.statusCode, message: "studyGroupsAddError " + error.message, level: 2, component: "SelectBaseCourse", line: 98 }))
            } else {
                navigate(`${disciplineId}/${resdata}`, { state: { disciplineName: disciplineName } });
            }
        })
    }

    return (
        <div className={classes.Disciplines}>
            {addNew &&
                <Discipline
                    key={0}
                    name={`+ ${texts.addNew} `}
                    active={true}
                    backgroundColor={"#C4C4C4"}
                    newFlag={true}
                    selectDisciplineCB={selectDisciplineCB}
                />
            }
            {filteredlist && filteredlist.map(c => (
                <div
                    key={c.id}
                    className={`${classes.WrapCourse} ${courseSelected && c.id === courseSelected.courseSelectedId && classes.WrapCourseSelected}`}>
                    <Discipline key={c.id} selectDisciplineCB={selectDisciplineCB} {...c} />
                    {isEditable &&
                        <ActionsPopup dropClass={classes.TextShaddow}>
                            <Action onClick={() => onDuplicateDiscipline(c.id)}>{texts.copy} {texts.dicispline}</Action>
                            <Action onClick={() => CreateNationalStudygroup(c.id, c.name)}>{texts.createNationalStudygroup}</Action>
                        </ActionsPopup>
                    }
                </div>
            ))}
            {messagePopup}
        </div>
    );
}

Disciplines.propTypes = {
    filteredlist: PropTypes.array
}

export default Disciplines;